import React from 'react';
import { Box, Radio } from '@mui/material';
import { theme } from '../../../constants/theme';
import { useThemeContext } from '../../../hook/useThemeManager';
import CloseIcon from '../../CustomSVGIcons/CloseIcon';
import CustomLazyLoadImage from '../../Image/CustomLazyLoadImage';

export interface IEmailImageTab {
    emailImage: string;
    isActive?: boolean;
    onClick?: () => void;
    readOnlyMode?: boolean;
    onClickRemove?: () => void;
}

const EmailImageTab: React.FC<IEmailImageTab> = ({ emailImage, isActive, onClick, readOnlyMode, onClickRemove }) => {
    const { themeStyle } = useThemeContext();
    const CLOUDFRONT = 'https://df41u66howm6r.cloudfront.net';

    return (
        <Box
            onClick={onClick}
            sx={{
                border: isActive
                    ? `0.5px solid ${theme[themeStyle].tag_white}`
                    : `0.5px solid ${theme[themeStyle].darkGray60}`,
                position: 'relative',
                width: '100%',
                maxHeight: '140px',
                display: 'flex',
                borderRadius: '10px',
                overflow: 'hidden',
            }}>
            <CustomLazyLoadImage
                src={`${CLOUDFRONT}/${emailImage}`}
                alt={'email'}
                style={{
                    objectFit: 'cover',
                    width: '100%',
                    opacity: 0.7,
                }}
            />
            <Radio
                sx={{
                    position: 'absolute',
                    right: 0,
                    top: '40%',
                }}
            />
            {readOnlyMode && <CloseIcon style={{ position: 'absolute', top: 0, right: 0 }} onClick={onClickRemove} />}
        </Box>
    );
};

export { EmailImageTab };
